function checkCropSize(className,xId,yId,wId,hId,resHtml){
    xStart = $('#'+xId).val();
    yStart = $('#'+yId).val();
    width = $('#'+wId).val();
    height = $('#'+hId).val();
    imgSrc = $(className).attr('src');

    if(width && height){
        $('#progressbar').show();
        $.ajax({
            type: 'POST',
            url: '/index/imagesize',
            dataType: 'json',
            data: {x: xStart, y: yStart, w: width, h:height, imgStr:imgSrc},
            success: function(response) {
                //consolo.log(response);
                $('#'+resHtml).html('Size: '+ response.size+' KB').show();
                $('#progressbar').hide();
            }

        });

    }else{
        // $('#message-box-info .mb-content').html('<p>Nothing Cropped</p>');
        // $('#message-box-info').toggleClass("open");
        alert('Nothing Cropped');
    }

}
$(document).ready(function(){

    // ---------------------------------------------------------
    var form = '';
    $(document).on('click', '.deleteaction', function() {
        var msg = "هل أنت متأكد من الحذف؟";
        form = this;

        delMsg = '';

        delMsg = $(this).attr('data-msg');

        if (delMsg) {
             deleteModal(delMsg);
        } else {
             deleteModal(msg);
        }

        return false;
    });

    //binds to onchange event of your input field
    $('.upload_image_class').bind('change', function() {
      //this.files[0].size gets the size of your file.
       var file = this.files[0];
        if (file.size > 1048576) { //image size not more then 1 mb

            var msg = `الحجم الأقصى المسموح به: 1MB`;
            var error_msg = $(this).attr('data-msg');

            if (error_msg) {
                 fileSizeMessage(error_msg);
            } else {
                 fileSizeMessage(msg);
            }

            $(this).val(null);
            
            var realConfirm=window.confirm;
            window.confirm=function(){
              window.confirm=realConfirm;
              return true;
            };
        }
    });

    function fileSizeMessage(message){
        $('#fileSizeMessage .message-content').html(message);
        $('#fileSizeMessage').modal('show');
    }

    function deleteModal(message, action) {
        $('#deleteMessage .message-content').text(message);
        $('#deleteMessage').modal('show');
    }

    $(document).on('click', '.submitDeleteModal', function() {
        $("#progressbar").show();
       form.submit();
    });
    // ---------------------------------------------------------

    $("#datatable-example.sortable tbody").sortable({
            helper: fixHelperModified,
            stop: updateIndex
        }).disableSelection();
    // Append modal to body 
    $('.modal').appendTo("body");

    $(document).on('click','.quicklinks #gear-icon',function(event){
        fixContextMenu(this);
    });

    $(window).scroll(function(e){
        var open = $('.quicklinks.open');
        if (open.length) {
            // if menu is opened and is opened to the top then make menu attached to element on scrolling
            var toggleButton = open.find('#gear-icon');
            var submenu = toggleButton.parent().children('ul');
            if (submenu.hasClass('fixed_menu')) {
                var menu_height = submenu.height();
                var scrollTop     = $(window).scrollTop(),
                elementOffset = toggleButton.offset().top,
                distance_from_top      = (elementOffset - scrollTop - menu_height - 10); // To adjust context menu position properly right above the button
                
                var left = toggleButton.offset().left;
                submenu.css('position','fixed');

                submenu.css('left',left);
                submenu.css('top',distance_from_top);
            }
        }
    });
});

function fixContextMenu(element) {
    var toggleButton = $(element);
    var submenu = toggleButton.parent().children('ul');
    submenu.removeClass('fixed_menu');
    var top = submenu.offset().top;
    var menu_height = submenu.height();
    var document_height = $(document).height();
    var scrollTop     = $(window).scrollTop(),
    elementOffset = $(element).offset().top,
    distance_from_top      = (elementOffset - scrollTop - menu_height - 10); // To adjust context menu position properly right above the button
    if (menu_height<180) {
        menu_height = 200;
    }
    var menu_bottom = top + menu_height;
    var done = false;
    if (menu_bottom>document_height) {
        // submenu.addClass('at-top');
        var left = $(element).offset().left;
        submenu.css('position','fixed');

        submenu.css('left',left);
        submenu.css('top',distance_from_top);
        done = true;
        submenu.addClass('fixed_menu');
    }
    // Add an extra check for tab view where menu goes inside the tab
    var isTabView = toggleButton.parents('.grid');
    // var isTabView = toggleButton.parents('.tab-pane.active');
    if (!done && isTabView.length>0) {
        var tab_height = isTabView.height();
        var tab_top = isTabView.offset().top; // calculate tab's distance from top
        var new_menu_bottom = menu_bottom - tab_top; // know we have to check that menu should not move down more than the tab-content height which makes us to scroll into hidden area so menu bottom should be calculated according to tab position in document
        if (new_menu_bottom>tab_height) { // check if menu exceeds the tab height
            // submenu.addClass('at-top');
            var left = $(element).offset().left;
            submenu.css('position','fixed');

            submenu.css('left',left);
            submenu.css('top',distance_from_top);
            submenu.addClass('fixed_menu');

        };

    };

}

function showDaleelProfilePopup(id){
    $('#progressbar').show();
    $.get('/admin/familymembers/'+id+'/profile-popup',{},function(response){
        $('#daleelProfilePopup .modal-content').html(response);
        $('#daleelProfilePopup').modal('show');
        $('#progressbar').hide();
    });
}
var fixHelperModified = function (e, tr) {
        var $originals = tr.children();
        var $helper = tr.clone();
        $helper.children().each(function (index) {
            $(this).width($originals.eq(index).width())
        });
        return $helper;
    },
            updateIndex = function (e, ui) {
                
                $('table tbody tr:odd').removeClass('alt-row');
                $('table tbody tr:even').removeClass().addClass('alt-row');
                var ids = [($('table tbody tr').size() - 1)];
                var idsIndex = 0;
                $('table tbody tr').each(function (i) {
                    rcheckbox = $(this).find(':checkbox');
                    if (rcheckbox.length > 0) {
                        ids[idsIndex] = rcheckbox.val();
                        idsIndex++;
                    }
                });
                rids = ids.join(',');
                var reorderUrl = $('table.sortable').attr('data-reorderUrl');
//                var reorderUrl = '<?php echo $this->url('admin/default', array('controller' => 'itempictures', 'action' => 'reorder', 'id' => $this->itemId)); ?>';
//                alert(reorderUrl);
                $.post(
                        reorderUrl,
                        {
                            ids: rids
                        },
                function (response) {

                },'json');

            };


// Return multiple uploadimages Info (images count and images)
// $(".upload-multiple-images").on('change', function() {
//   var numFiles = $(this)[0].files.length;
//   $("#upload-multiple-images-preview").html("");
//   readURL(this);
//   numFiles > 0 ? $('.selectedImagesCount').text(' عدد الصور '+numFiles) : $('.selectedImagesCount').text('');
// });

$(".upload-multiple-images").on('change', function() {

    var images = $(this)[0].files;
    var big_sized_images = [];
    $.each( images, function( key, file ) {
      if (file.size > 1048576) {
        big_sized_images.push(file.name);
      }
    });

    if(big_sized_images.length > 0)
    {
      $(this).val(null);
      $('.selectedImagesCount').text('');
      var files_names = '';
      var msg = `الحجم الأقصى المسموح به: 1MB<br><br><span style="color:red;">`+ big_sized_images.join("<br>")+`</span>`;
      fileSizeMessage(msg);
    }else{
      var numFiles = $(this)[0].files.length;
      $("#upload-multiple-images-preview").html("");
      readURL(this);
      numFiles > 0 ? $('.selectedImagesCount').text(' عدد الصور '+numFiles) : $('.selectedImagesCount').text('');
    }

});

function fileSizeMessage(message){
    $('#fileSizeMessage .message-content').html(message);
    $('#fileSizeMessage').modal('show');
}
function readURL(input) {

  if (input.files) {
    $.each(input.files, function(index, file) {
        var reader = new FileReader();
        reader.onload = function (e) {
          $("#upload-multiple-images-preview").append(`<a  class="gallery-item " data-gallery="request_gallery_upload_preview" href="`+e.target.result+`"><img id="`+index+`" src="`+e.target.result+`" class="listing-icon m-b-10 m-r-10 img-thumbnail" /></a>`)
        }
        reader.readAsDataURL(file);
    }); 
  }
  
}
// -------------------- end multiple images config --------------------------------

// ---------------------------------- start popup confirmation modal --------------

    $(document).on('click', '.markaction #del', function (e) {
        e.preventDefault();
        bulkActionModal(this,'',true);
    });
    $(document).on('click', '.markaction #del2', function (e) {
        e.preventDefault();
        bulkActionModal(this,'2',true);
    });
    $(document).on('click', '.markaction #del3', function (e) {
        e.preventDefault();
        bulkActionModal(this,'3',true);
    });

    $(document).on('click', '.markaction #show', function (e) {
        e.preventDefault();
        bulkActionModal(this,'');
    });
    $(document).on('click', '.markaction #show2', function (e) {
        e.preventDefault();
        bulkActionModal(this,'2');
    });

    $(document).on('click', '.markaction #hide', function (e) {
        e.preventDefault();
        bulkActionModal(this,'');
    });
    $(document).on('click', '.markaction #hide2', function (e) {
        e.preventDefault();
        bulkActionModal(this,'2');
    });

    var errorMessageStr = 'يجب إختيار إستمارة أو أكثر';
    var msg = "هل أنت متأكد من الحذف؟";
    function bulkActionModal(element,count,confirm_delete){
      url = $(element).attr('data-url');
      var selectedCheckboxItems = $('#datatable-example'+count+' tbody :checkbox:checked').map(function () {
          return this.value;
      }).get();
      
      if (selectedCheckboxItems.length > 0) {
        selectedItem = selectedCheckboxItems.join(',');
        selectedItems = selectedItem.replace('on,', '');
        delMsg = '';

        if (confirm_delete) {
            delMsg = $(element).attr('data-msg');

            if (delMsg) {
                 deleteBulkModal(delMsg);
            } else {
                 deleteBulkModal(msg);
            }
        }else{
            $("#progressbar").show();
            $('#ids').attr('value', selectedItems);
            $('#bulkaction').attr('action', url);
            $('#bulkaction').submit();
        }
          
      } else {
          showErrorMessage(errorMessageStr);
      }
    }

    function deleteBulkModal(message, action) {
        $('#deleteBulkMessage .message-content').text(message);
        $('#deleteBulkMessage').modal('show');
    }

    $(document).on('click', '.submitDeleteBulkModal', function() { 
        $("#progressbar").show();
        $('#ids').attr('value', selectedItems);
        $('#bulkaction').attr('action', url);
        $('#bulkaction').submit();
    });


// ---------------------------------- start popup confirmation modal --------------

// check image fulfill desired aspect ratio while uploading
function checkCropOk(ascpect_ratio,cropped_width_height_elements,image){

    try {
        //original width and height of image
        var originalWidth = image[0].naturalWidth;
        var originalHeight = image[0].naturalHeight;

        //cropped width and height of image
        var cropped_width = Number($('#'+cropped_width_height_elements.split(',')[0]).val());
        var cropped_height = Number($('#'+cropped_width_height_elements.split(',')[1]).val());

        var aspect_width = Number(ascpect_ratio.split(':')[0]);
        var aspect_height = Number(ascpect_ratio.split(':')[1]);

        //acpect ratio value of original width and height
        var original_Aspect = Number(( originalWidth / aspect_width ) * aspect_height).toFixed(0);
        var original_Aspect_diff = Number(originalHeight - original_Aspect);

        //acpect ratio value of cropped width and height
        var cropped_Aspect = Number(( cropped_width / aspect_width ) * aspect_height).toFixed(0);
        var cropped_Aspect_diff = Number(cropped_height - cropped_Aspect);
        
        var difference = cropped_width && cropped_height ? cropped_Aspect_diff : original_Aspect_diff;
        var which_diff = cropped_width && cropped_height ? 'cropped' : 'original';

        if(difference > (which_diff == 'cropped' ? -15 : -7) && difference < (which_diff == 'cropped' ? 15 : 7)) {
            return true;
        }else{
            // return "Image must be exactly "+aspect_width+":"+aspect_height+" in dimension";
            return "مقاس صورة الغلاف يجب أن تتكون من أضعاف "+aspect_width+":"+aspect_height;
        }
    }

    catch(err){
        return true;
    }
    
 } 

// char counter for text input
function updateFeatureCharLimitNum(textarea,limitElement,limitNum){
    var field = document.getElementById(textarea);
    
    if (field.value.length > limitNum) {
        field.value = field.value.substring(0, limitNum);
    } else {
        $('#'+limitElement).html(limitNum - field.value.length);
    }
}

